import { StateCreator } from 'zustand';

const AUTH_SET_AUTH_DATA = 'AUTH_SET_AUTH_DATA';
const AUTH_SET_ACCESS_TOKEN = 'AUTH_SET_ACCESS_TOKEN';
const AUTH_SET_SESSION_ID = 'AUTH_SET_SESSION_ID';

interface AuthState {
  accessToken?: string;
  sessionId?: string;
}

interface AuthActions {
  clearAuthData: () => void;
  getAuthData: () => AuthState;
  setAccessToken: (accessToken: string) => void;
  setAuthData: (authData: AuthState) => void;
  setSessionId: (sessionId: string) => void;
}

export type AuthSlice = {
  auth: AuthState & AuthActions;
};

const initialState: AuthState = {
  accessToken: undefined,
  sessionId: undefined,
};

export const createAuthSlice: StateCreator<
  AuthSlice,
  [['zustand/devtools', never]]
> = (set, get) => ({
  auth: {
    ...initialState,
    clearAuthData: () => {
      set(
        (state) => {
          return {
            auth: {
              ...state.auth,
              accessToken: undefined,
              sessionId: undefined,
            },
          };
        },
        false,
        AUTH_SET_ACCESS_TOKEN,
      );
    },
    getAuthData: () => {
      const { accessToken, sessionId } = get().auth;

      return {
        accessToken,
        sessionId,
      };
    },
    setAccessToken: (accessToken) => {
      set(
        (state) => {
          return {
            auth: {
              ...state.auth,
              accessToken,
            },
          };
        },
        false,
        AUTH_SET_ACCESS_TOKEN,
      );
    },
    setAuthData: (authData) => {
      set(
        (state) => {
          return {
            auth: {
              ...state.auth,
              ...authData,
            },
          };
        },
        false,
        AUTH_SET_AUTH_DATA,
      );
    },
    setSessionId: (sessionId) => {
      set(
        (state) => {
          return {
            auth: {
              ...state.auth,
              sessionId,
            },
          };
        },
        false,
        AUTH_SET_SESSION_ID,
      );
    },
  },
});
